import HealthRecordTransmitForm from './HealthRecordTransmitForm';

export default HealthRecordTransmitForm;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordTransmitForm/index.js